document.addEventListener("DOMContentLoaded", function () {
    const containers = document.querySelectorAll(".image-download-center");

    if (containers.length) {
        import(/* webpackChunkName: "idc" */"/Features/ImageDownload/js/image-download-center.js").then(async (ImageDownloadCenter) => {
            containers.forEach(() => {
                const imageDownloadCenter = new ImageDownloadCenter.default();
                imageDownloadCenter.init();
            });
        });
    }
});